
import { RouteObject } from "react-router-dom"
import DeviceType from '../components/mfIoT/device/DeviceType';
import DeviceModel from '../components/mfIoT/device/DeviceModel';
import Device from '../components/mfIoT/device/Device';
import Firmware from '../components/mfIoT/firmware/Firmware';

import Topic from '../components/mfIoT/mqtt/Topic';
import TopicGroup from '../components/mfIoT/mqtt/TopicGroup';
import MqttMsg from '../components/mfIoT/mqtt/MqttMsg';

const mfRouter: RouteObject[] = [
    {
        path: "/deviceType",
        element: <DeviceType />,
    },
    {
        path: "/deviceModel",
        element: <DeviceModel />,
    },
    {
        path: "/device",
        element: <Device />,
    },
    {
        path: "/firmware",
        element: <Firmware />,
    },
    {
        path: "/topic",
        element: <Topic />,
    },
    {
        path: "/topicGroup",
        element: <TopicGroup />,
    },
    {
        path: "/mqttMsg",
        element: <MqttMsg />,
    },

];


export default mfRouter;